export function webfont() {
  //web fonts 遅延読み込み用

  // (function () {
  //   var webfonts = document.getElementById("gwebfont");
  //   webfonts.rel = "stylesheet";
  // })();

  //WEBフォントの数だけ追加
  /*
	(function () {
	var webfonts2 = document.getElementById('gwebfont2');
	webfonts2.rel = 'stylesheet';
  })();
*/

  (function () {
    var webfonts2 = document.getElementById("gwebfont2");
    webfonts2.rel = "stylesheet";
  })();
}
